import { v4 as uuidv4 } from "uuid";
import SharePlacesImg from "../images/shareplaces-cover.png";
import WavesImg from "../images/waves-cover.png";
import CustomManagementImg from "../images/custom-management-cover.png";
import CheckinbdImg from "../images/checkinbd-cover.png";
import ComfySlothImg from "../images/comfy-sloth-cover.png";
import WhatsAppCloneImg from "../images/whatsapp-clone-cover.png";
import JobsterImg from "../images/jobster-cover.png";
import TraverseImg from "../images/traverse-cover.png";
import SquadDeckImg from "../images/squaddeck-cover.png";
import OfficeManagementImg from "../images/office-management-cover.png";

const projects = [
  {
    id: uuidv4(),
    name: "SquadDeck",
    desc: "SquadDeck is an all-in-one sports team management system that streamlines player, coach, and parent management with features for scheduling, communication, and more.",
    img: SquadDeckImg,
    link: "https://squaddeck.com/",
    repo: "",
  },
  {
    id: uuidv4(),
    name: "Office Management",
    desc: "Office Management that handles employee profiles, salary details, leave records, asset tracking, and office accounts, also integrated income and expense management.",
    img: OfficeManagementImg,
    link: "https://office.inleadsit.com/",
    repo: "",
  },
  {
    id: uuidv4(),
    name: "ComfySloth",
    desc: "ComfySloth is a shopping website with a shopping cart system. You can buy products and make payment using stripe.",
    img: ComfySlothImg,
    link: "https://comfybd.netlify.app/",
    repo: "https://github.com/tanvir1418/comfy-ecom",
  },
  {
    id: uuidv4(),
    name: "Whatsapp Clone",
    desc: "WhatsApp clone is a messaging platform similar to the actual WhatsApp. In this application, user can login, register, send messages, create groups, search for users, user online status, show when a user is typing, make video calls, etc.",
    img: WhatsAppCloneImg,
    link: "https://whats-app-bd.netlify.app/",
    repo: "https://github.com/tanvir1418/whatsapp-clone",
  },
  {
    id: uuidv4(),
    name: "Jobster",
    desc: "Jobster is a simple application for tracking user job applications to various companies and updating job statuses over time. Users can add, update, delete, and filter job applications.",
    img: JobsterImg,
    link: "https://jobster-brqc.onrender.com/",
    repo: "https://github.com/tanvir1418/jobster-app",
  },
  {
    id: uuidv4(),
    name: "SharePlaces",
    desc: "SharePlaces is a platform where an individual can share their travel experience about that place with others.",
    img: SharePlacesImg,
    link: "https://share-places-bd.netlify.app/",
    repo: "https://github.com/tanvir1418/place-sharing-app",
  },
  {
    id: uuidv4(),
    name: "Custom-Management-System",
    desc: "This is a custom management system project which handles a huge amount of user data and visualizes data in complex tables and various graphs.",
    img: CustomManagementImg,
    link: "https://custom-management.netlify.app/",
    repo: "https://github.com/tanvir1418/custom-management",
  },
  {
    id: uuidv4(),
    name: "CheckinBD",
    desc: "CheckinBD is a website which deals with booking hotel rooms online.",
    img: CheckinbdImg,
    link: "https://checkinbd.netlify.app/",
    repo: "https://github.com/tanvir1418/checkinbd-frontend",
  },
  {
    id: uuidv4(),
    name: "Traverse",
    desc: "Traverse is your go-to landing page for unforgettable locations, perfect for adventurous travelers. Join us in exploring exotic destinations and booking your dream trip!",
    img: TraverseImg,
    link: "https://traverse-tailwind.netlify.app/",
    repo: "https://github.com/tanvir1418/traverse-tailwindcss",
  },
  {
    id: uuidv4(),
    name: "Waves",
    desc: "Waves is an e-commerce platform for selling guitars where users can find their preferred guitars.",
    img: WavesImg,
    link: "https://waves-guiters.herokuapp.com/",
    repo: "https://github.com/tanvir1418/waves",
  },
];

export default projects;
